import styled from '@emotion/styled'
import { Container, Grid, useTheme } from '@mui/material'
import React from 'react'
import {  SectionHeading, SectionSmallHeading, SectionWrapper } from '../../Styles/style'

const Detail = styled.div`

background:linear-gradient(180deg, #000, #1E1E1E);
border-radius:10px;
padding:0 20px;
margin:20px 0px;

 `
const S6_Tokenomics = () => {
    const theme = useTheme()
    return (
        <div>
            <SectionWrapper p="14rem 0" bgColor="linear-gradient(90deg, #FFDC00 ,#FFDC00,#E58E2F,#DB2D72,#FF00FF)" id="tokenomics">
                <Container maxWidth="xl">
                    <SectionHeading align="center" p="10px 0 20px" m="0" data-aos="flip-up"
                        data-aos-easing="ease-in"
                        data-aos-delay="500"
                        data-aos-duration="500"
                        data-aos-offset="0">How To Buy</SectionHeading>
                    <Grid container justifyContent="center">
                        <Grid item xs={12} md={8}  lg={7} xl={6.5}data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Detail>
                                <SectionSmallHeading>1 - Create Your Wallet</SectionSmallHeading>
                            </Detail>
                        </Grid>
                       
                        <Grid item xs={12} md={8}  lg={7} xl={6.5}data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Detail>
                                <SectionSmallHeading>2 - Bridged $WPLS to MetaMask</SectionSmallHeading>
                            </Detail>
                        </Grid>
                       
                        <Grid item xs={12} md={8} lg={7} xl={6.5} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Detail>
                                <SectionSmallHeading>3 - Visit $BABYHEX on PulseX</SectionSmallHeading>
                            </Detail>
                        </Grid>
                       
                        <Grid item xs={12} md={8} lg={7} xl={6.5} data-aos="fade-up"
                            data-aos-anchor-placement="center-bottom" data-aos-delay="500"
                            data-aos-duration="500">
                            <Detail>
                                <SectionSmallHeading>4 - Swap $WPLS for $BABYHEX</SectionSmallHeading>
                            </Detail>
                        </Grid>
                       
                    </Grid>
                </Container>
            </SectionWrapper>
        </div>
    )
}

export default S6_Tokenomics